<!-- =========================================================================================
    File Name: Attività.vue
    Description: Calendario delle attività
    ----------------------------------------------------------------------------------------
    Item Name:
      Author:
    Author URL:
========================================================================================== -->


<template>
    <div>
      <search-bar @create="handleNew" @find="cercaAttivita" :filter_list="['Tutti','Telefonata','Mail','Appuntamento','Altro','Tirocinio','Impegno personale','Door to Door','Aperta','Completato','Scaduto']" :newTexts="['Nuova']" tooltip="Tipo Attività"></search-bar>
      <vs-table :pagination="events.length > 10" :max-items="10" :data="events">
          <template slot="thead">
            <!-- <vs-th :key="i" v-for="(e, i) in ['Tipo', 'Descrizione', '', 'Fonte', 'Responsabile', 'Stato', 'Completata', '']">{{e}}</vs-th> -->
            <vs-th :key="i" v-for="(e, i) in ['Tipo', 'Descrizione', 'Fonte', 'Azienda/Contatto', 'Responsabile', 'Stato', 'Completata', '']">{{e}}</vs-th>
          </template>

          <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="row-no-pointer">

                <vs-td :data="data[indextr].tipo">
                  <vx-tooltip :text="data[indextr].tipo" position="left" class="tr-tooltip">
                    <vs-button class="no-pointer-event inline-block p-1" v-if="data[indextr].tipo == 'Appuntamento'" type="flat" icon-pack="feather" icon="icon-bell"></vs-button>
                    <vs-button class="no-pointer-event inline-block p-1" v-else-if="data[indextr].tipo == 'Telefonata'" type="flat" icon-pack="feather" icon="icon-phone"></vs-button>
                    <vs-button class="no-pointer-event inline-block p-1" v-else-if="data[indextr].tipo == 'Mail'" type="flat" icon-pack="feather" icon="icon-mail"></vs-button>
                    <vs-button class="no-pointer-event inline-block p-1" v-else-if="data[indextr].tipo == 'Altro'" type="flat" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                    <vs-button class="no-pointer-event inline-block p-1" v-else-if="data[indextr].tipo == 'Tirocinio'" type="flat" icon-pack="feather" icon="icon-award"></vs-button>
                    <vs-button class="no-pointer-event inline-block p-1" v-else-if="data[indextr].tipo == 'Door to Door'" type="flat" icon-pack="feather" icon="icon-wind"></vs-button>
                    <vs-button class="no-pointer-event inline-block p-1" v-else-if="data[indextr].tipo == 'Impegno personale'" type="flat" icon-pack="feather" icon="icon-user"></vs-button>
                    <vs-button class="no-pointer-event inline-block p-1" v-else type="flat" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                  </vx-tooltip>
                </vs-td>

                <vs-td :data="tr.descrizione">
                  {{tr.descrizione}}
                </vs-td>

                <vs-td :data="[tr['azienda'],tr['contatto'],tr['lead']]">
                  <vx-tooltip v-if="tr['azienda'] && tp_active" text="Azienda" position="left" class="tr-tooltip">
                    <vs-button class="inline-block p-1" @click="goTo(tr['azienda']['id'],'aziende')" type="flat" icon-pack="feather" icon="icon-grid"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="tr['contatto'] && tp_active" text="Contatto" position="left" class="tr-tooltip">
                    <vs-button class="inline-block p-1" @click="goTo(tr['contatto']['id'],'contatti')" type="flat" icon-pack="feather" icon="icon-phone-call"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="tr['lead'] && tp_active" text="Lead" position="left" class="tr-tooltip">
                    <vs-button class="inline-block p-1" @click="goTo(tr['lead']['id'],'leads-elenco')" type="flat" icon-pack="feather" icon="icon-activity"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="!tr['lead'] && !tr['contatto'] && !tr['azienda']" text="Attività generica" position="left" class="tr-tooltip">
                    <vs-button class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-calendar"></vs-button>
                  </vx-tooltip>
                </vs-td>

                <vs-td v-if="tr['azienda'] && tp_active" :data="tr.azienda">
                  {{tr.azienda.ragione_sociale}}
                </vs-td>
                <vs-td v-if="tr['contatto'] && tp_active" :data="tr.contatto">
                  {{[tr.contatto.cognome,tr.contatto.nome].join(' ')}}
                </vs-td>
                <vs-td v-if="tr['lead'] && tp_active" :data="tr.lead">
                  {{tr.lead.azienda ? tr.lead.azienda.ragione_sociale : [tr.lead.contatto.cognome,tr.lead.contatto.nome].join(' ')}}
                </vs-td>
                <vs-td v-if="!tr['lead'] && !tr['contatto'] && !tr['azienda']" :data="[tr['azienda'],tr['contatto'],tr['lead']]">
                  ATTIVITÀ GENERICA
                </vs-td>

                <vs-td :data="tr.responsabile">
                  {{[tr.responsabile.cognome,tr.responsabile.nome].join(' ')}}
                </vs-td>

                <vs-td :data="[tr.data_scadenza,tr.data_completamento]">
                  <vx-tooltip v-if="tr.data_scadenza < new Date() && !tr.data_completamento" text="Scaduto" position="left" class="tr-tooltip">
                    <vs-button class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-zap-off"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-else-if="tr.data_completamento" text="Completato" position="left" class="tr-tooltip">
                    <vs-button class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-check"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-else text="Aperta" position="left" class="tr-tooltip">
                    <vs-button class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-watch"></vs-button>
                  </vx-tooltip>
                </vs-td>

                <vs-td :data="data[indextr].data_completamento">
                    {{data[indextr].data_completamento ? $tariffe.formatDateNew(data[indextr].data_completamento) : ''}}
                </vs-td>

                <vs-td>
                  <vs-row vs-justify="flex-end">
                    <vx-tooltip text="Dettaglio">
                      <vs-button @click="showAtt(data[indextr], $event)" radius color="primary" type="line" icon-pack="feather" icon="icon-eye"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-if="!tr.data_completamento" text="Modifica">
                      <vs-button @click="showAttivita(data[indextr], $event)" class="ml-2" radius color="warning" type="line" icon-pack="feather" icon="icon-edit"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="Elimina">
                      <vs-button @click="handleEliminaAttivitaLead(data[indextr].id, $event)" class="ml-2" radius color="danger" type="line" icon-pack="feather" icon="icon-trash"></vs-button>
                    </vx-tooltip>
                  </vs-row>
                </vs-td>

              </vs-tr>
          </template>
      </vs-table>

    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-utenti" spacer v-model="isSidebarActive">
      <sidebar-form-attivita-lead :id_az="this.target.id_az" :id_cont="this.target.id_cont" :selected_date="null" @close-me="sidebarClose" @elimina-attivita-lead="handleEliminaAttivitaLead($event)" :altre_attivita="[]" :id_lead="selected && selected.id_lead ? _.cloneDeep(selected.id_lead) : null" @attivita-lead-salvato="handleSave" v-if="sidebar_type === 'form-attivita-lead'" :key="formkey" :selected="selected" :tir="tirocinio" />
      <sidebar-attivita :selected_date="null" @close-me="sidebarClose" @elimina-attivita-lead="handleEliminaAttivitaLead($event)" :altre_attivita="[]" :id_lead="selected && selected.id_lead ? _.cloneDeep(selected.id_lead) : null" @attivita-lead-salvato="handleSave" v-if="sidebar_type === 'show-attivita-lead'" :key="formkey" :selected="selected"></sidebar-attivita>
    </vs-sidebar>
  </div>
</template>

<script>

import axios from 'axios'
import SidebarFormAttivitaLead from '../boards/SidebarFormAttivitaLead.vue'
import SidebarAttivita from '../boards/SidebarAttivita.vue'
import SearchBar from '../commons/SearchBar.vue'


export default {
  name: 'app',
  data: () => ({
    events: [],
    showDate: new Date(),
    haveSaved: false,
    sidebar_type: null,
    sidebar_active: false,
    formkey: null,
    selected: null,
    tirocinio: {},
    tp_active: true,
    keyword: "",

    icon: {
      Telefonata: 'icon-phone-call',
      Mail: 'icon-mail',
      Appuntamento: 'icon-calendar',
      Altro: 'icon-more-vertical',
    },
    target: {
      id_az: null,
      id_cont: null,
    },
  }),
  components: {
    SidebarFormAttivitaLead,
    SearchBar,
    SidebarAttivita
  },
  mounted()
  {
    this.getAttivitaLead()
    let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
    if (elements.length) {
      elements[0].remove();
    }
    if (this.$route.params.type) {
      setTimeout(() => this.handleNew(), 500)
    }
    this.target.id_az = null
    if (this.$route.params.az_id) {
      this.target.id_az = this.$route.params.az_id
      setTimeout(() => this.handleNew(), 500)
    }
    this.target.id_cont = null
    if (this.$route.params.cont_id) {
      this.target.id_az = this.$route.params.cont_id
      setTimeout(() => this.handleNew(), 500)
    }
    this.target.id_lead = null
    if (this.$route.params.lead_id) {
      this.target.id_lead = this.$route.params.lead_id
      setTimeout(() => this.handleNew(), 500)
    }
  },
  computed: {
    isSidebarActive: {
      get() {
        return this.sidebar_active
      },
      set(val) {
        if(!val && this.haveSaved) {
          this.haveSaved = false
        }
        else {
          this.sidebar_active = val
        }
      }
    }
  },
  methods: {
    handleNew() {
      this.sidebar_type = 'form-attivita-lead'
      this.selected = null
      this.formkey = Math.random()
      this.sidebar_active = !this.sidebar_active
    },
    setShowDate(d) {
      this.showDate = d
      this.formkey = Math.random()
    },
    handleSave() {
      this.sidebarClose()
      // this.isSidebarActive = !this.sidebar_active
      this.haveSaved = true
      this.formkey = Math.random()
      // this.selected = null
      this.selected_stato = null
      this.selected_lead = null
      this.selected_attivita = null
      this.getAttivitaLead()
    },
    showAttivita(attivita, ev) {
      this.formkey = Math.random()
      if (ev) {
        ev.stopPropagation()
      }
      this.selected = this.events.find(e => e.id == attivita.id)
      this.sidebar_type = 'form-attivita-lead'
      this.haveSaved = false
      this.isSidebarActive = !this.sidebar_active
    },
    showAtt(attivita, ev) {
      this.formkey = Math.random()
      if (ev) {
        ev.stopPropagation()
      }
      this.selected = this.events.find(e => e.id == attivita.id)
      this.sidebar_type = 'show-attivita-lead'
      this.haveSaved = false
      this.isSidebarActive = !this.sidebar_active
    },
    addAttivita() {
      this.selected = null
      this.sidebar_type = 'form-attivita-lead'
      this.formkey = Math.random()
      this.isSidebarActive = !this.sidebar_active
    },
    handleEliminaAttivitaLead(id,ev) {
      if (ev) {
        ev.stopPropagation()
      }
      if (this.isSidebarActive) {
        this.isSidebarActive = !this.sidebar_active
      }
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/attivita_lead/elimina', { id: id },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        })
        .then(() => {
          this.haveSaved = true
          this.getAttivitaLead()
        } )
        .catch(e => console.log(e))
    },
    cercaAttivita(k,opt) {
      this.keyword = k
      this.option = opt
      this.getAttivitaLead()
    },
    getAttivitaLead() {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      let tipologia = 'tipo'
      if (this.option == 'Aperta' || this.option == 'Completato' || this.option == 'Scaduto') {
        tipologia = 'data'
      }
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/get_attivita_lead', {
        option: this.option ? this.option : "Tutti",
        keyword: this.keyword,
        type: tipologia,
      }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      })
      .then(response => {
        this.events = []
        response.data.forEach(e => {
          e['title'] = e['nome']
          e['classes'] = "feather "
          e['classes'] += this.icon[e['tipo']] + " "
          e['classes'] += e['tipo'].toLowerCase()
          this.events.push(e)
        })
        this.$vs.loading.close()
      })
      .catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
    },
    sidebarClose() {
      this.selected = null
      this.sidebar_active = false
    },
    goTo(id,type) {
      this.tp_active = false
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
      this.$router.push({ name: type, params: { wanted_id: id } })
    }
  }
}
</script>

<style>
.cv-week {
  min-height: 86px;
}

.cv-header {
  min-height: 4em;
}

.cv-day {
  padding: 2px;
}

.theme-default .cv-header, .theme-default .cv-header-day {
  background-color: #fff;
}

.appuntamento {
  background-color: #7367f0 !important;
}

.telefonata {
  background-color: #0088cc !important;
}

.mail {
  background-color: #3dcc00 !important;
}
</style>
